module.exports = __webpack_public_path__ + "24826197.png";